import React, { PropTypes } from 'react';
import JacketViewButton from '@bibliocommons/base-jacket-view-button';
import ListViewButton from '@bibliocommons/base-list-view-button';
import GroupedSearchButton from '@bibliocommons/base-grouped-search-button';
import cn from 'classnames';

const ViewSelector = ({ currentView, searchActions, groupedSearchEnabled }) => {
  const toggleSearchView = view => searchActions.toggleSearchView(view);
  const groupedSearchButton = <GroupedSearchButton currentView={currentView} toggleListView={toggleSearchView} />;
  const selectorClasses = cn(
    'cp-view-selector',
    'btn-group',
    {
      'hidden-sm hidden-xs': !groupedSearchEnabled
    }
  );

  return (
    <div className={selectorClasses}>
      <ListViewButton className="hidden-sm hidden-xs" currentView={currentView} toggleListView={toggleSearchView} />
      <JacketViewButton currentView={currentView} toggleListView={toggleSearchView} />
      { groupedSearchEnabled && groupedSearchButton }
    </div>
  );
};

ViewSelector.propTypes = {
  searchActions: PropTypes.objectOf(PropTypes.func).isRequired,
  currentView: PropTypes.string.isRequired,
  groupedSearchEnabled: PropTypes.bool.isRequired
};


export default ViewSelector;



// WEBPACK FOOTER //
// ./app/components/search/ViewSelector/ViewSelector.jsx